@if (checkingSession()) {
  <div
    class="flex min-h-dvh flex-col items-center justify-center bg-linear-to-b from-zinc-960 to-zinc-975 px-4 font-brand">
    <img
      src="./assets/images/logos/incidite-head-white.svg"
      alt="Incidite"
      class="h-6 w-auto" />
    <p
      class="mt-5 flex items-center gap-1.5 text-13 tracking-tight text-zinc-400"
      role="status">
      <vx-icon
        name="circle-notch"
        size="sm"
        class="animate-spin motion-reduce:animate-none" />
      {{ 'pages.auth.login.checkingSession' | transloco }}
    </p>
  </div>
} @else if (loadFailed()) {
  <div
    class="flex min-h-dvh flex-col items-center justify-center bg-linear-to-b from-zinc-960 to-zinc-975 px-4 text-center font-brand"
    role="alert">
    <img
      src="./assets/images/logos/incidite-head-white.svg"
      alt="Incidite"
      class="h-6 w-auto" />
    <h1 class="mt-5 text-2xl leading-6.5 tracking-tight text-zinc-50">
      {{ 'pages.auth.login.loadFailed.title' | transloco }}
    </h1>
    <p class="mt-2 max-w-sm text-sm tracking-tight text-zinc-400">
      {{ 'pages.auth.login.loadFailed.body' | transloco }}
    </p>
    <div class="mt-8 flex flex-wrap justify-center gap-3">
      <vx-button size="lg" (click)="retryApp()">
        {{ 'pages.auth.login.loadFailed.retry' | transloco }}
      </vx-button>
      <vx-button
        size="lg"
        variant="outline"
        [loading]="signingOut()"
        (click)="useOtherAccount()">
        {{ 'pages.auth.login.loadFailed.otherAccount' | transloco }}
      </vx-button>
    </div>
  </div>
} @else if (aal === 'aal1') {
  <app-auth-shell [testimonial]="false">
    <img
      src="./assets/images/logos/incidite-head-white.svg"
      alt="Incidite"
      class="h-6 w-auto self-start" />
    <h1 class="mt-5 text-2xl leading-6.5 tracking-tight text-zinc-50">
      {{ 'pages.auth.login.title' | transloco }}
    </h1>
    <p class="mt-2 text-sm tracking-tight text-zinc-400">
      {{ 'pages.auth.login.subtitle' | transloco }}
    </p>

    @if (providers().length) {
      <app-oidc-buttons
        class="mt-7.5"
        intent="login"
        [providers]="providers()"
        [busy]="isCompletingLoginFlow()"
        (picked)="signInWith($event)" />
      <hr class="mt-8 border-zinc-800" />
    }

    <form
      class="mt-8 flex flex-col gap-5 rounded-2xl bg-zinc-800 p-5 inset-ring inset-ring-zinc-750"
      [formGroup]="form"
      (ngSubmit)="submit()"
      novalidate>
      <vx-form-field [label]="'pages.auth.login.emailLabel' | transloco">
        <vx-input
          size="lg"
          type="email"
          name="email"
          formControlName="email"
          autocomplete="username" />
      </vx-form-field>

      <vx-form-field
        [label]="'pages.auth.login.passwordLabel' | transloco"
        [hint]="'pages.auth.login.passwordHint' | transloco">
        <a
          vxFormFieldLabelAction
          class="text-13 tracking-tight text-zinc-400 hover:text-zinc-200"
          routerLink="/recovery"
          [state]="{ email: form.controls.email.value }">
          {{ 'pages.auth.login.forgotPassword' | transloco }}
        </a>
        <vx-input
          size="lg"
          type="password"
          name="password"
          formControlName="password"
          autocomplete="current-password"
          [revealLabel]="'pages.auth.login.showPassword' | transloco" />
      </vx-form-field>

      @if (messages().length) {
        <app-kratos-messages [messages]="messages()" />
      }

      @if (noAccount()) {
        <p class="text-13 tracking-tight text-zinc-400" role="alert">
          {{
            'pages.auth.login.noAccount'
              | transloco: { email: form.controls.email.value }
          }}
          <a
            class="font-medium text-zinc-200 underline underline-offset-2 hover:text-zinc-50"
            routerLink="/register"
            [state]="{ email: form.controls.email.value }">
            {{ 'pages.auth.login.createAccount' | transloco }}
          </a>
        </p>
      }

      <vx-button
        type="submit"
        size="lg"
        [fullWidth]="true"
        [loading]="isCompletingLoginFlow()">
        {{ 'pages.auth.login.signIn' | transloco }}
      </vx-button>
    </form>

    <p class="mt-5 text-center text-sm tracking-tight text-zinc-400">
      {{ 'pages.auth.login.noAccountYet' | transloco }}
      <a
        class="text-zinc-200 underline underline-offset-2 hover:text-zinc-50"
        routerLink="/register">
        {{ 'pages.auth.login.signUp' | transloco }}
      </a>
    </p>
  </app-auth-shell>
}

@if (aal === 'aal2') {
  <app-auth-shell [testimonial]="false">
    @if (twoFAFlow) {
      <app-two-factor
        [flow]="twoFAFlow"
        (signedIn)="onLoginCompleted($event)" />
    }
    <p class="mt-5 text-center text-13 tracking-tight text-zinc-400">
      @if (twoFAEmail()) {
        {{ 'pages.auth.twoFactor.notYou' | transloco: { email: twoFAEmail() } }}
      }
      <button
        type="button"
        class="text-zinc-200 underline underline-offset-2 hover:text-zinc-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-50"
        [disabled]="signingOut()"
        (click)="useOtherAccount()">
        {{ 'pages.auth.twoFactor.useOtherAccount' | transloco }}
      </button>
    </p>
    <app-auth-help />
  </app-auth-shell>
}
